import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import DifferentiatorSection from "@/components/DifferentiatorSection";
import Treatments from "@/components/Treatments";
import DrSection from "@/components/DrSection";
import Gallery from "@/components/Gallery";
import Memberships from "@/components/Memberships";
import VideoTestimonial from "@/components/VideoTestimonial";
import Reviews from "@/components/Reviews";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import HomeFaq, { useHomeFaqs } from "@/components/HomeFaq";

const Index = () => {
  const faqs = useHomeFaqs();

  return (
    <main className="min-h-screen">
      <SEO page="home" faqs={faqs} />
      <Navbar />
      <Hero />
      <Treatments />
      <DifferentiatorSection />
      <DrSection />
      <Memberships />
      <Gallery />
      <VideoTestimonial />
      <Reviews />
      <HomeFaq />
      <Contact />
      <Footer />
    </main>
  );
};

export default Index;
